module.exports = __webpack_public_path__ + "static/media/pending.9f42b06f.svg";